import { Select } from './select';
import { SelectTrigger } from './select-trigger';
import { SelectContent } from './select-content';
import { Option } from './select-option';
import { SelectValue } from './select-value';
import { Input } from '../input';
import { withAliases } from '../../../ui/utils/with-aliases';
var SelectComponent = withAliases(Select, {
    Option: Option,
    Trigger: SelectTrigger,
    Content: SelectContent,
    Label: Input.Label,
    Value: SelectValue,
});
export { SelectComponent as Select };
